import Section from "components/molecules/SectionTracker";
import Footer from "components/organisms/Footer";
import Brand from "./Home/Brand";
import Packages from "./Home/Packages";
import Process from "./Home/Process";
import Services from "./Home/Service";
import Contact from "./Home/Contact";

const BrandView = () => {
  return (
    <div className="w-full" style={{ background: "var(--site-bg)", color: "var(--site-text)" }}>
      <Section id={"Brand"} children={<Brand />} addedStyle="group w-full min-h-screen text-center flex flex-col gap-6 justify-start items-center py-32 mobile:py-20" />
      <Section id={"Packages"} children={<Packages />} addedStyle="group w-full min-h-screen text-center flex flex-col gap-6 justify-start items-center py-32 mobile:py-20" />
      <Section id={"Process"} children={<Process />} addedStyle="group w-full min-h-screen text-center flex flex-col gap-6 justify-start items-center py-32 mobile:py-20" />
      <Section id={"Service"} children={<Services />} addedStyle="w-full min-h-screen text-center flex flex-col gap-6 justify-start items-center py-32 mobile:py-20" />
      <Section id={"Contact"} children={<Contact />} addedStyle="group w-full h-fit min-h-screen flex justify-center items-center py-32 mobile:py-20" />
      <Section id={"My Resume"} children={<Footer />} addedStyle="group w-full h-fit min-h-screen flex justify-center items-center" />
    </div>
  );
};

export default BrandView;
